export default __webpack_public_path__ + "static/media/bell.1f6789fa.svg";